import Material from '@components/common/faq-material'
import { FAQ } from '@lib/data/course-landing-page'
import { useState } from 'react'

type Props = {
  courseName: string
  title?: string
}

const Faq = ({ courseName, title }: Props) => {
  const [activeAccordion, setActiveAccordion] = useState('')

  return (
    <div className="container mx-auto mt-16">
      <h2 className="text-xl md:text-2xl font-600 mb-10 leading-tight">
        {title ? title : 'Frequently Asked Questions'}
      </h2>
      {FAQ[courseName].map(({ questionName, acceptedAnswerText }, index) => (
        <Material
          key={index}
          title={questionName}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
        >
          <p className="text-base">{acceptedAnswerText}</p>
        </Material>
      ))}
    </div>
  )
}

export default Faq
